import React, {useContext, useState} from 'react'
import PlusIcon from "../../../../statics/assets/icons/plus.svg"
import {SettingTenantContext} from "../../context/SettingTenantContext"
import parseToken from "../../../../helpers/parseToken"
import {Button, Checkbox, message, Modal, Popconfirm, Select} from "antd"
import {addSettingTenantParam} from "../../../../services/api/apiSetting"
import moment from "moment/moment"

const AddTenantParam = () => {
    const SettingTenantPageContext = useContext(SettingTenantContext)
    const {
        getListSettingTenant,
        listTenant,
        listParam,
    } = SettingTenantPageContext

    const info = parseToken()

    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [validate, setValidate] = useState({})
    const [error, setError] = useState('')
    const [item, setItem] = useState({
        status: 1,
        startDateCheckTalkTime: moment(),
        typeLimitTalkTime: 'MONTH'
    })


    const _onToggleModal = () => {
        setIsOpen(!isOpen)
    }

    const _onCancel = () => {
        setIsOpen(false)
        _resetInfo()
    }

    const _resetInfo = () => {
        setItem({
            status: 1
        })
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target
        setItem({
            ...item,
            [name]: value
        })

        setError('')
        delete validate[name]
    }

    const _handleChangeChecked = (e) => {
        const checked = e.target.checked

        const {name} = e.target
        setItem({
            ...item,
            [name]: checked ? 1 : 0
        })

        setError('')
        delete validate[name]
    }

    const _handleChangeSelect = (name, value) => {
        setItem({
            ...item,
            [name]: value
        })
        setError('')
        delete validate[name]
    }

    const _validateData = () => {
        let validateForm = {}

        if (item.tenantId === undefined || item.tenantId === '') {
            Object.assign(validateForm, {tenantId: 'Tenant là bắt buộc'})
        }

        if (item.parName === undefined || item.parName === '') {
            Object.assign(validateForm, {parName: 'Tham số là bắt buộc'})
        }

        if (item.parValue === undefined || item.parValue === '') {
            Object.assign(validateForm, {parValue: 'Giá trị là bắt buộc'})
        }

        setValidate(validateForm)

        return validateForm
    }

    const onAddSettingTenantParam = async () => {
        setLoading(true)

        try {
            const validateCheck = _validateData()

            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)
                message.error("Dữ liệu không hợp lệ")

                return false
            }

            const response = await addSettingTenantParam(item, info.sub)
            const {success, error_message} = response

            if (success !== '1') {
                setLoading(false)
                message.error(error_message)

                return false
            }

            setLoading(false)
            message.success("Thêm mới setting tenant thành công.")
        } catch (e) {
            message.error(e.message)
        }
    }

    const _onSave = async () => {
        const response = await onAddSettingTenantParam()

        if (response !== false) {
            if (typeof getListSettingTenant === 'function') {
                await getListSettingTenant()
            }
            _onCancel()
        }
    }

    const _onSaveAndNew = async () => {
        const response = await onAddSettingTenantParam()
        if (response !== false) {
            if (typeof getListSettingTenant === 'function') {
                await getListSettingTenant()
            }
            await _resetInfo()
        }
    }

    return (
        <>
            <button className="ButtonCustom mr-3" onClick={_onToggleModal}>
                <PlusIcon width={12} height={12}/>
                Thêm mới
            </button>
            <Modal
                title="Thêm mới tenant setting"
                className="ModalCustom2 FormEdit"
                maskClosable={false}
                visible={isOpen}
                footer={[
                    <div className="Actions d-flex justify-content-end align-items-center">
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={_onCancel}
                                    okText="Yes" cancelText="No">
                            <Button key="back" type="link" disable={loading}>
                                Cancel
                            </Button>
                        </Popconfirm>
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu và tạo mới setting tenant?"
                                    onConfirm={_onSaveAndNew} okText="Yes" cancelText="No">
                            <Button key="submit2" loading={loading}>
                                Save & New
                            </Button>
                        </Popconfirm>
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu setting tenant?" onConfirm={_onSave}
                                    okText="Yes" cancelText="No">
                            <Button key="submit" type="primary" loading={loading}>
                                Save
                            </Button>
                        </Popconfirm>
                    </div>
                ]}>
                <div className="FormAddNew">
                    <div className="row">
                        <div className="col-md-12">
                            <div className={`FieldItem ${validate.parTitle && 'error'}`}>
                                <label className="Label" htmlFor="parTitle">
                                    Tiêu đề:
                                </label>
                                <input
                                    id="parTitle"
                                    value={item.parTitle || ''}
                                    type="text"
                                    name="parTitle"
                                    placeholder="Tiêu đề"
                                    onChange={_handleChangeInput}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.tenantId && 'error'}`}>
                                <label className="Label" htmlFor="tenantId">
                                    Tenant:
                                    <span className="Required">*</span>
                                </label>
                                <Select id="tenantId " name="tenantId" defaultValue={item.tenantId} showSearch
                                        onChange={(value) => _handleChangeSelect('tenantId', value)}
                                        placeholder="Vui lòng chọn tenant"
                                        filterOption={
                                            (input, option) => option.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                >
                                    {
                                        listTenant.map((item, index) => (
                                            <Select.Option key={`tenantId${index}`} value={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        ))
                                    }
                                </Select>
                                {
                                    validate.tenantId && <span className="Error text-danger">{validate.tenantId}</span>
                                }
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.parName && 'error'}`}>
                                <label className="Label" htmlFor="parName">
                                    Tham số:
                                    <span className="Required">*</span>
                                </label>
                                <Select id="parName " name="parName" defaultValue={item.parName} showSearch
                                        onChange={(value) => _handleChangeSelect('parName', value)}
                                        placeholder="Vui lòng chọn tham số"
                                        filterOption={
                                            (input, option) => option.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                >
                                    {
                                        listParam.map((item, index) => (
                                            <Select.Option key={`parName${index}`} value={item.name}>
                                                {item.name}
                                            </Select.Option>
                                        ))
                                    }
                                </Select>
                                {
                                    validate.parName && <span className="Error text-danger">{validate.parName}</span>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.parValue && 'error'}`}>
                                <label className="Label" htmlFor="parValue">
                                    Giá trị:
                                    <span className="Required">*</span>
                                </label>
                                <input
                                    id="parValue"
                                    value={item.parValue || ''}
                                    type="text"
                                    name="parValue"
                                    placeholder="Giá trị"
                                    onChange={_handleChangeInput}
                                />
                                {
                                    validate.parValue &&
                                    <span className="Error text-danger">{validate.parValue}</span>
                                }
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.status && 'error'}`}>
                                <label className="Label" htmlFor="fieldRequired">
                                    Trạng thái:
                                </label>
                                <Checkbox
                                    id="status"
                                    name='status'
                                    checked={item.status === 1}
                                    onChange={_handleChangeChecked}
                                >
                                    Trạng thái
                                </Checkbox>
                            </div>
                        </div>
                    </div>

                    {error && <div className="text-danger mt-3">{error}</div>}
                </div>
            </Modal>
        </>
    )
}

export default AddTenantParam
